import { useRequest } from './chunk-SNCLEEAV.mjs';
import { useAuthContext } from './chunk-K3UDKV2P.mjs';
import { graphql } from './chunk-NWN55YVG.mjs';

// src/listen/query-hooks/manage.ts
var manageQuery = graphql(`
  query ListenManage($userId: uuid!) {
    audios(
      where: { user_id: { _eq: $userId } }
      order_by: { createdAt: desc }
    ) {
      id
      name
      source
      thumbnailUrl
      artistName
      audio_tags {
        tag_id
      }
    }
    tags(
      where: { site: { _eq: "listen" } }
      order_by: { display_order: asc }
    ) {
      id
      name
    }
    playlist(
      where: { user_id: { _eq: $userId }, site: { _eq: "listen" } }
      order_by: { createdAt: desc }
    ) {
      id
      title
      slug
      description
      thumbnailUrl
    }
  }
`);
var transformAudio = (audio) => {
  var _a;
  return {
    id: audio.id,
    name: audio.name,
    artistName: audio.artistName,
    thumbnailUrl: audio.thumbnailUrl || "",
    source: audio.source,
    tagIds: ((_a = audio.audio_tags) != null ? _a : []).map((t) => t.tag_id)
  };
};
var useLoadManage = () => {
  var _a, _b, _c;
  const { user, getAccessToken } = useAuthContext();
  const userId = (_a = user == null ? void 0 : user.id) != null ? _a : "";
  const { data, isLoading, error } = useRequest({
    queryKey: ["listen-manage"],
    getAccessToken,
    document: manageQuery,
    variables: { userId },
    enabled: Boolean(userId)
  });
  return {
    audios: data ? data.audios.map(transformAudio) : [],
    feelings: (_b = data == null ? void 0 : data.tags) != null ? _b : [],
    playlists: (_c = data == null ? void 0 : data.playlist) != null ? _c : [],
    isLoading,
    error
  };
};

export { useLoadManage };
//# sourceMappingURL=chunk-JADFDJ23.mjs.map
//# sourceMappingURL=chunk-JADFDJ23.mjs.map